export const PAGE_SIZE = 10;

export interface PaginationModel {
  pageSize: number;
  defaultPageSize: number;
  totalPages: number;
  currentPage: number;
  startPage: number;
  endPage: number;
}

export interface PaginatedResponse {
  total_pages: number;
  total_elements: number;
  pageable: PageableObject;
  sort: PaginationSort;
  first: boolean;
  last: boolean;
  number: number;
  number_of_elements: number;
  size: number;
  empty: boolean;
}

export interface PageableObject {
  page_number: number;
  page_size: number;
  sort: PaginationSort;
  paged: boolean;
  unpaged: boolean;
  offset: number;
}

export interface PaginationSort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}
